import Lookup from 'src/componentes/select2';

const ProbabilidadeRiscoLookup = (props) => {
  return (
    <Lookup
      title="nome"
      labelKey="nome"
      valueKey="id"
      url={
        props.isLoading || props.options ? null : '/ProbabilidadeRiscoLookup'
      }
      clearable={false}
      ignoreURLWithOptions={true}
      {...props}
    />
  );
};

export default ProbabilidadeRiscoLookup;
